type Props = {
  className?: string;
  size?: number;
};

/**
 * Claros brand mark — three-color polygonal peak.
 * Source of truth: public/favicon.svg.
 */
export function LogoMark({ className, size = 22 }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path d="M60 12.06L18.696 57.48L60 67.56L61.008 42.36Z" fill="#3A5BC7" opacity="0.95" />
      <path d="M60 12.06L61.008 42.36L102.312 57.48L81.144 29.76Z" fill="#6C5CE7" opacity="0.9" />
      <path d="M18.696 57.48L60 67.56L102.312 57.48L60 110.4Z" fill="#0EA5A0" opacity="0.9" />
      <path d="M60 67.56L61.008 42.36L102.312 57.48Z" fill="#6C5CE7" opacity="0.25" />
    </svg>
  );
}

/**
 * Full horizontal lockup — uses the canonical asset shipped by the
 * dashboard so the wordmark + colours stay in lockstep across products.
 */
export function Logo({ className }: Props) {
  return (
    <img
      src="/claros-logo-full.svg"
      alt="Claros"
      width={132}
      height={33}
      className={className}
    />
  );
}
